import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type Session from "cc-frontend/services/session"

interface Sig {}

export default class SetupPermissionsNotice extends Component<Sig> {
  @service declare session: Session

  @service router

  @action
  signInOrUp() {
    let path = this.router.currentURL

    this.router.transitionTo("user.sign", { queryParams: { afterSignInRedirectTo: path } })
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    SetupPermissionsNotice: typeof SetupPermissionsNotice
  }
}
